import React, {useState} from 'react';
import AdminUploadEpisodeModal from './AdminUploadEpisodeModal';
import styles from './RoboticDataAdmin.module.css';

// The server grants this preview only to the uploader or an authenticated Admin.
export default function RejectedEpisodePreview({episodeId, episode, upload, token, isAdmin = false}) {
    const [open, setOpen] = useState(false);
    return <>
        <button type="button" className={styles.filterChip} onClick={() => setOpen(true)}>Review video</button>
        {open && <AdminUploadEpisodeModal
            episode={{...episode, episode_id: episodeId, status: 'QA_REJECTED'}}
            upload={upload}
            adminMode={isAdmin}
            adminToken={isAdmin ? token : ''}
            previewToken={token}
            onClose={() => setOpen(false)}
        />}
    </>;
}
